import React from "react";

import MetadataFileDiscoveryView from "./MetadataFileDiscoveryView";

const MetadataDiscoveryReport = () => {
  return <MetadataFileDiscoveryView />;
};

export default MetadataDiscoveryReport;
